"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyRoutes = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var layout_1 = require("../components/layout");
var home_1 = require("../pages/home");
var login_1 = require("../pages/login");
var mis_datos_1 = require("../pages/mis-datos");
var mis_mascotas_1 = require("../pages/mis-mascotas");
var pass_1 = require("../pages/pass");
var reportar_mascota_1 = require("../pages/reportar-mascota");
var sign_up_1 = require("../pages/sign-up");
var editar_mascota_1 = require("../pages/editar-mascota");
function MyRoutes() {
    return (react_1.default.createElement(react_router_dom_1.Routes, null,
        react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(layout_1.Layout, null) },
            react_1.default.createElement(react_router_dom_1.Route, { index: true, element: react_1.default.createElement(home_1.Home, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/mis-datos", element: react_1.default.createElement(mis_datos_1.MisDatos, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/mis-mascotas", element: react_1.default.createElement(mis_mascotas_1.MisMascotas, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/reportar-mascota", element: react_1.default.createElement(reportar_mascota_1.ReportarMascota, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/login", element: react_1.default.createElement(login_1.Login, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/pass", element: react_1.default.createElement(pass_1.Pass, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/sign-up", element: react_1.default.createElement(sign_up_1.SignUp, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/editar-mascota", element: react_1.default.createElement(editar_mascota_1.EditarMascota, null) }))));
}
exports.MyRoutes = MyRoutes;
